import {html, LitElement} from "../libs/lit.dist.js";
import './pk-icon.js';
import './pk-spinner.js';

export class PkSpinnerIcon extends LitElement {

    static get properties() {
        return {
            spinner: {type: Boolean},
            color: {type: String},

            // Icon
            icon: {type: String},
            type: {type: String},
            light: {type: Boolean},
            solid: {type: Boolean},
            dualTone: {type: Boolean},
            collection: {type: String},
            fixedWidth: {type: Boolean},

            // Spinner
            spinnerSize: {type: String},
        };
    }

    constructor() {
        super();
        this.spinner = false;
        this.color = '';
        this.icon = '';
        this.type = '';
        this.collection = 'fa';
        this.spinnerSize = 'sm';
    }

    get #iconType() {
        if (this.type) {
            return this.type;
        }

        if (this.light) {
            return 'light';
        }

        if (this.solid) {
            return 'solid';
        }

        if (this.dualTone) {
            return 'dualTone';
        }

        return '';
    }

    render() {
        if (this.spinner) {
            return html`
                <slot name="spinner">
                    <pk-spinner size="${this.spinnerSize}" color="${this.color}"></pk-spinner>
                </slot>
            `
        }
        return html`
            <slot>
                <pk-icon 
                    collection="${this.collection}" 
                    type="${this.#iconType}" 
                    icon="${this.icon}" 
                    .fixedWidth="${this.fixedWidth}"
                ></pk-icon>
            </slot>
        `;
    }
}

if (!customElements.get('pk-spinner-icon')) {
    customElements.define('pk-spinner-icon', PkSpinnerIcon);
}
